import colors from './colors';
import constants from './constants';
import { elevation, gradients, layout } from './mixins';
import typography from './typography';

export default {
    colors,
    constants,
    elevation,
    gradients,
    layout,
    typography
};
